import React from 'react';
import { Pagination } from 'react-admin';

const ListPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200]} {...props} />;

export default ListPagination;
